// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PTFQfmr4Bw12SC0nC4cP{height:100%;margin-right:-25px;overflow:hidden}.aOcNsyjv8Gor4QFi3O1Z{padding-bottom:16px;padding-right:20px}.VArwefi8PmsvBqFQvBtx{max-height:100%}._NgHRrXmgiqZrWHAoCps{width:100%;height:23px;color:var(--content-primary-disabled);justify-content:center;align-items:center;margin-bottom:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `PTFQfmr4Bw12SC0nC4cP`,
	"scrollbar__content": `aOcNsyjv8Gor4QFi3O1Z`,
	"scrollbarContent": `aOcNsyjv8Gor4QFi3O1Z`,
	"scrollbar__view": `VArwefi8PmsvBqFQvBtx`,
	"scrollbarView": `VArwefi8PmsvBqFQvBtx`,
	"date": `_NgHRrXmgiqZrWHAoCps`
};
export default ___CSS_LOADER_EXPORT___;
